"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrillOriginItem = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var model_1 = require("../../../../model");
exports.DrillOriginItem = function (_a) {
    var localIdentifier = _a.localIdentifier, onDelete = _a.onDelete, title = _a.title, type = _a.type, isDateAttribute = _a.isDateAttribute;
    var onClick = function () {
        onDelete(localIdentifier);
    };
    var shouldRenameMeasureToMetric = model_1.useDashboardSelector(model_1.selectEnableRenamingMeasureToMetric);
    var iconType = isDateAttribute
        ? "date"
        : shouldRenameMeasureToMetric && type === "measure"
            ? "metric"
            : type;
    var iconClassName = "dm-button-icon dm-button-icon-" + iconType;
    return (react_1.default.createElement("div", { className: "gd-drill-config-measure-item" },
        react_1.default.createElement("div", { className: iconClassName }),
        react_1.default.createElement("div", { className: "dm-button-title s-drill-config-item-title", title: title }, title),
        react_1.default.createElement("div", { className: "dm-button-delete-wrapper" },
            react_1.default.createElement(sdk_ui_kit_1.Button, { className: "drill-config-item-delete gd-button-link gd-button-icon-only gd-icon-cross s-drill-config-item-delete", onClick: onClick }))));
};
//# sourceMappingURL=DrillOriginItem.js.map